<template>
    <v-container fluid style="margin: 60px 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.EnviosYDevoluciones') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
            <v-col cols="12" align="center"  style="margin-bottom:60px">
                <h1 :style="responsiveTitulo" class="titulo">{{$t('Menu.EnviosYDevoluciones')}}</h1>
            </v-col>
            <v-col cols="12" align="center" style="margin-bottom: 50px">
                <h3 class="font-weight-regular">{{$t('Envios.Descripcion')}}</h3>
            </v-col>
            <v-col cols="12" style="padding: 0 10%" class="mb-5">
                <v-expansion-panels focusable accordion flat>
                    <v-expansion-panel v-for="(i, index) in informacion" :key="index">
                        <v-expansion-panel-header class="vietnam subtitle-1" v-if="getIdioma === 'es'" style="word-break:break-word;">
                          {{ i.tituloEs }}
                          <template v-slot:actions>
                            <v-icon color="primary">$expand</v-icon>
                          </template>
                          </v-expansion-panel-header>
                        <v-expansion-panel-header class="vietnam subtitle-1" style="word-break:break-word;" v-else>
                          {{ i.tituloEn }}
                          <template v-slot:actions>
                            <v-icon color="primary">$expand</v-icon>
                          </template>
                          </v-expansion-panel-header>
                        <v-expansion-panel-content class="pa-5 vietnam" v-if="getIdioma === 'es'">{{ i.descripcionEs }}</v-expansion-panel-content>
                        <v-expansion-panel-content class="pa-5 vietnam" v-else>{{ i.descripcionEn }}</v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters } from 'vuex'
export default {
  name: 'EnviosYDevoluciones',
  mounted () {
    firebase.firestore().collection('utilidades').doc('envios').get().then(doc => {
      this.informacion = doc.data().envios
    })
  },
  data () {
    return {
      informacion: []
    }
  },
  computed: {
    ...mapGetters(['getIdioma']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  }
}
</script>

<style>
.titulo {
  font-family: 'Be Vietnam', sans-serif!important;
  font-weight: 600!important;
}
</style>
